import { useTranslation } from '@/i18n';
import { ButtonV2 } from '@moneyforward/ap-frontend-components';
import classnames from 'classnames/bind';
import { FC, memo } from 'react';
import styles from './BulkDeleteButtonGroup.module.scss';

const cx = classnames.bind(styles);

export type BulkDeleteButtonGroupProps = {
  selectedCount: number;
  onBulkDelete: () => void;
};

export const BulkDeleteButtonGroup: FC<BulkDeleteButtonGroupProps> = memo(
  ({ selectedCount, onBulkDelete }) => {
    const { t } = useTranslation();
    if (selectedCount === 0) {
      return null;
    }

    return (
      <div className={cx('root')} data-testid='admin-bulk-delete-button-group'>
        <span className={cx('count-label')}>
          {t('admin_invoice_reports.action_menu.bulk_delete_button_label', {
            count: selectedCount,
          })}
        </span>
        <ButtonV2
          color='danger'
          isSecondary
          onClick={onBulkDelete}
          data-testid='admin-bulk-delete-button'
          size='sm'
        >
          {t('admin_invoice_reports.actions.delete')}
        </ButtonV2>
      </div>
    );
  }
);

BulkDeleteButtonGroup.displayName = 'AdminBulkDeleteButtonGroup';
